module.exports = __webpack_public_path__ + "img/use-safari@2x.230ea02d.png";